const reducer = (state = false, action) =>{
    switch(action.type){
        case "setUserSession": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;   